<template>
    <div class="flex justify-between items-center">
        <Avatar :url="avatar" :first-name="firstName" :last-name="lastName" class="ml-2 mr-2" />
        <div class="text-gray flex-1">
            <div class="text-[13px] leading-[13px] font-normal text-ellipsis overflow-hidden max-w-40">
                <div class="truncate">{{ lastName }}</div>
                <div class="truncate">{{ firstName }} {{ middleName }}</div>
            </div>
            <div class="mt-0.5 text-[10px]">
                <p class="truncate max-w-32">{{ position }}</p>
            </div>
        </div>
        <div v-if="store.isEmployeeStatsVisible" class="timesheet-employee-totals w-11 pl-2 text-gray text-[11px] flex flex-col items-center justify-center">
            <div>{{ mainFact }}</div>
            <div>{{ additionalFact }}</div>
            <div class="border-b border-graylight w-6"></div>
            <div>{{ mainFact + additionalFact }}</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import Avatar from '../Avatar.vue'
import {computed} from 'vue'
import { useScheduleStore } from '@/stores/scheduleStore'

interface Props {
    id: string,
    firstName: string,
    lastName: string,
    middleName?: string | null,
    position?: string,
    avatar: string
}

const store = useScheduleStore()

const {id} = defineProps<Props>()

const days = computed(() => store.timesheets.find(item => item.employment_id === id)?.timesheet?.days)
const mainFact = computed(() => (Math.floor(getTotals(days.value, 'main_seconds')/3600)))
const additionalFact = computed(() => (Math.floor(getTotals(days.value, 'additional_seconds')/3600)))
function getTotals(days:any, field: any) {
    let res = 0
    for(let key in days) {
       res += days[key].totals[field]
    }
    return res
}
</script>

<style scoped>
.timesheet-employee-totals {
    /* Align summary values with the adjacent timesheet day values. */
    transform: translateY(-3px);
}
</style>
